import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "stats-panel" }
const _hoisted_2 = { class: "panel-label" }
const _hoisted_3 = { class: "pf-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "자치구", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "전체 서울", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "pf-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "법정동", -1)
const _hoisted_9 = { class: "pf-row pf-area" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<label> 전용 평형 (평) <span class=\"info-ic\" tabindex=\"0\">ⓘ <span class=\"info-pop\"> 입력값은 <b>전용면적</b> 기준입니다.<br> · 전용 = 실제 사용 공간(발코니 제외)<br> · 공급 = 전용 + 공용(복도·계단 등)<br> 분양에서 흔히 말하는 <b>‘34평’은 공급 기준</b>이고, <b>국평(국민평형)</b>은 전용 84㎡ ≈ <b>전용 25평</b>(공급 34평)입니다. </span></span></label>", 1)
const _hoisted_11 = { class: "pf-pair" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "~", -1)
const _hoisted_13 = { class: "area-extra" }
const _hoisted_14 = {
  key: 0,
  class: "area-hint"
}
const _hoisted_15 = { class: "area-presets" }
const _hoisted_16 = { class: "pf-row pf-span2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "기간", -1)
const _hoisted_18 = { class: "pf-pair" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "~", -1)
const _hoisted_20 = { class: "pf-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "집계 단위", -1)
const _hoisted_22 = { class: "pf-seg" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "panel-body" }
const _hoisted_25 = { class: "stat-grid" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "sk-line sk-sm" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "sk-line sk-lg" }, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "chart-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sk-block" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "dist-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sk-block sk-dist" })
], -1)
const _hoisted_31 = {
  key: 0,
  class: "trunc-note"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "전체 기간", -1)
const _hoisted_33 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_34 = { class: "stat-grid" }
const _hoisted_35 = { class: "stat-label" }
const _hoisted_36 = {
  key: 0,
  class: "stat-sub"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "dl-tag" }, "좌 대비", -1)
const _hoisted_38 = { class: "chart-block" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "chart-cap" }, [
  /*#__PURE__*/_createTextVNode(" 거래량 · 평균가 추이 "),
  /*#__PURE__*/_createElementVNode("span", { class: "cap-hint" }, "— 실선: 평균가·거래량 / 파선: 최고~최저 범위 / 점선: 중앙값. 표시 항목을 켜고 끄면 반영됩니다.")
], -1)
const _hoisted_40 = { class: "chart-box" }
const _hoisted_41 = { class: "dist-block" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "chart-cap" }, "평형별 거래 비중", -1)
const _hoisted_43 = { class: "dist-list" }
const _hoisted_44 = { class: "dist-band" }
const _hoisted_45 = { class: "dist-bar-wrap" }
const _hoisted_46 = { class: "dist-val" }
const _hoisted_47 = {
  key: 2,
  class: "empty-hint idle"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "조회", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "panel-head",
      style: _normalizeStyle({ borderTopColor: _ctx.accent })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "panel-dot",
          style: _normalizeStyle({ background: _ctx.accent })
        }, null, 4),
        _createTextVNode(" " + _toDisplayString(_ctx.summaryLabel), 1)
      ]),
      (_ctx.removable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "panel-remove",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove'))),
            title: "비교 제거"
          }, "×"))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("form", {
      class: "panel-filter",
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.run && _ctx.run(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.f.sggCd) = $event))
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guOptions, (name, code) => {
            return (_openBlock(), _createElementBlock("option", {
              key: code,
              value: code
            }, _toDisplayString(name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.f.sggCd]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.f.umdNm) = $event)),
          placeholder: "예: 전농동"
        }, null, 512), [
          [_vModelText, _ctx.f.umdNm]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.f.minPy) = $event)),
            placeholder: "최소"
          }, null, 512), [
            [_vModelText, _ctx.f.minPy]
          ]),
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.f.maxPy) = $event)),
            placeholder: "최대"
          }, null, 512), [
            [_vModelText, _ctx.f.maxPy]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.areaHint)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.areaHint), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.preset('kook'))),
              title: "국민평형 · 전용 84㎡"
            }, "국평"),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.preset('small')))
            }, "~20평"),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.preset('mid')))
            }, "25~32평"),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.preset('big')))
            }, "40평~")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.f.from) = $event))
          }, null, 512), [
            [_vModelText, _ctx.f.from]
          ]),
          _hoisted_19,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.f.to) = $event))
          }, null, 512), [
            [_vModelText, _ctx.f.to]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ on: _ctx.f.group === 'MONTH' }),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.f.group = 'MONTH'))
          }, "월별", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({ on: _ctx.f.group === 'YEAR' }),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.f.group = 'YEAR'))
          }, "연도별", 2)
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "pf-run",
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.loading ? '집계 중…' : '조회'), 9, _hoisted_23)
    ], 32),
    _createElementVNode("div", _hoisted_24, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                return _createElementVNode("div", {
                  class: "stat-card sk",
                  key: 'sk-' + n
                }, _hoisted_28)
              }), 64))
            ]),
            _hoisted_29,
            _hoisted_30
          ], 64))
        : (_ctx.loaded)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.truncated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_ctx.seriesMode)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 거래 건수·평균가·추이는 "),
                          _hoisted_32,
                          _createTextVNode(" 기준입니다. 중앙값·평단가·최고/최저·평형분포는 최근 " + _toDisplayString(_ctx.sampleCount.toLocaleString()) + "건 표본 기준이며, 조건을 좁히면 전 구간이 반영됩니다. ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 표본 상한(" + _toDisplayString(_ctx.MAX.toLocaleString()) + "건)에 도달해 최근 거래 위주로 집계됐습니다. 기간·조건을 좁히면 더 정확합니다. ", 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stats.count === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "조건에 맞는 거래가 없습니다."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMetrics, (m) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stat-card",
                          key: m.key
                        }, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(m.label), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["stat-value", { accent: m.accent }])
                          }, _toDisplayString(m.value), 3),
                          (m.sub)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(m.sub), 1))
                            : _createCommentVNode("", true),
                          (m.delta)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["stat-delta", m.deltaDir])
                              }, [
                                _hoisted_37,
                                _createTextVNode(" " + _toDisplayString(m.delta), 1)
                              ], 2))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        (_ctx.chartData)
                          ? (_openBlock(), _createBlock(_component_LineChart, {
                              key: 0,
                              data: _ctx.chartData,
                              options: _ctx.chartOptions
                            }, null, 8, ["data", "options"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dist, (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "dist-row",
                            key: d.band
                          }, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(d.band), 1),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", {
                                class: "dist-bar",
                                style: _normalizeStyle({ width: d.ratio + '%', background: _ctx.accent })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(d.count.toLocaleString()) + "건 · " + _toDisplayString(d.ratio.toFixed(0)) + "%", 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 64))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createTextVNode("조건을 설정하고 "),
              _hoisted_48,
              _createTextVNode("를 누르세요.")
            ]))
    ])
  ]))
}